import React from "react";
import EyeNoData from "../../../components/Nav & Header/Eye";

function NoNovels() {
  return (
    <div className="mt-[50px] lg:mt-[100px] mb-[200px] md:gap-y-[0px] lg:gap-y-[40px] flex flex-col items-center justify-center w-full">
      <div className="nodatazoom">
        <EyeNoData />
      </div>
      <div className=" space-y-6 font-SoraR capitalize flex justify-center items-center  max-w-[300px] text-[20px] m-auto text-center">
        <h1 className="text-[14px] sm:text-[16px] font-SoraL">
          User has not created any novels To Display!
        </h1>
      </div>
    </div>
  );
}

export default NoNovels;
